/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React, { FC } from "react";
import { DOC_ERROR_SEVERITY } from "@adapptio/lib-blueprint";
import { ErrorList } from "../../../../ui/components/ErrorList/ErrorList";
import { ERROR_LIST_CATEGORY } from "../../../../ui/components/ErrorList/ErrorListTypes";
import { getErrorGroups } from "../../mocks/data/errorGroups";

export interface ITestModuleConsoleContentProps {
	severityFilter?: Set<DOC_ERROR_SEVERITY> | null;
}

const errorGroups = getErrorGroups();

export const TestModuleConsoleContent: FC<ITestModuleConsoleContentProps> = ({ severityFilter }) => {
	return (
		<ErrorList
			errorGroups={errorGroups}
			category={ERROR_LIST_CATEGORY.ALL}
			severityFilter={severityFilter}
		/>
	);
};
